import { Card } from "../../Components/ui/card";
import { PageLayout } from "../../Components/PageLayout";
import { useGetInstance } from "../../Hooks/use-get";
import { useMutate } from "../../Hooks/use-mutate";
import { useParams } from "react-router-dom";
import { Spinner } from "../../Components/LoadingAnimations/LoadingAnimations";
import { Form } from "../../Components/ui/form/form";
import { Input } from "../../Components/ui/form/input/input";
import { Option, Select } from "../../Components/ui/form";
import { useEffect, useState } from "react";
import { Button } from "../../Components/ui/button";
import { useNavigate } from "react-router-dom";

type Supplier = {
	id: number;
	name: string;
	address: string;
	city: string;
	state: string;
	zip_code: string;
	country: string;
	phone: string;
	email: string;
	currency: "USD" | "MXN";
};

type SupplierFormData = {
	name: string;
	address: string;
	city: string;
	state: string;
	zip_code: string;
	country: string;
	phone: string;
	email: string;
	currency: "USD" | "MXN";
};

const currencyOptions: Option[] = [
	{
		optionLabel: "USD",
		optionValue: "USD",
	},
	{
		optionLabel: "MXN",
		optionValue: "MXN",
	},
];

const SupplierRoute = () => {
	const params = useParams<{ id: string }>();
	const navigate = useNavigate();

	const result = useGetInstance<Supplier>("/safety/suppliers/" + params.id);
	const submitResult = useMutate<SupplierFormData>(
		"/safety/suppliers/" + params.id,
		"PUT",
	);

	const [name, setName] = useState(result.data?.name || "");
	const [address, setAddress] = useState(result.data?.address || "");
	const [city, setCity] = useState(result.data?.city || "");
	const [state, setState] = useState(result.data?.state || "");
	const [zipCode, setZipCode] = useState(result.data?.zip_code || "");
	const [country, setCountry] = useState(result.data?.country || "");
	const [phone, setPhone] = useState(result.data?.phone || "");
	const [email, setEmail] = useState(result.data?.email || "");
	const [currency, setCurrency] = useState<"USD" | "MXN">(
		result.data?.currency || "USD",
	);

	useEffect(() => {
		if (result.data) {
			setName(result.data.name);
			setAddress(result.data.address);
			setCity(result.data.city);
			setState(result.data.state);
			setZipCode(result.data.zip_code);
			setCountry(result.data.country);
			setPhone(result.data.phone);
			setEmail(result.data.email);
			setCurrency(result.data.currency || "USD");
		}
	}, [result.data]);

	const handleSubmit = async (e: React.SubmitEvent) => {
		e.preventDefault();
		try {
			await submitResult.mutate({
				name,
				address,
				city,
				state,
				zip_code: zipCode,
				country,
				phone,
				email,
				currency,
			});
			result.fetchData();
		} catch (error) {
			console.error("Failed to update supplier", error);
		}
	};

	return (
		<>
			{result.isLoading ? (
				<Spinner />
			) : (
				<PageLayout title={name || "Supplier"} header="suppliers">
					<Button
						labelKey="back"
						variant="secondary"
						onClick={() => navigate("/suppliers")}
					/>
					<Card title={name || "Supplier"} size="md">
						<Form onSubmit={handleSubmit} isLoading={submitResult.isLoading}>
							<Input
								label="name"
								value={name}
								onChange={(e) => setName(e.target.value)}
							/>
							<Input
								label="address"
								value={address}
								onChange={(e) => setAddress(e.target.value)}
							/>
							<Input
								label="city"
								value={city}
								onChange={(e) => setCity(e.target.value)}
							/>
							<Input
								label="state"
								value={state}
								onChange={(e) => setState(e.target.value)}
							/>
							<Input
								label="zip"
								value={zipCode}
								onChange={(e) => setZipCode(e.target.value)}
							/>
							<Input
								label="country"
								value={country}
								onChange={(e) => setCountry(e.target.value)}
							/>
							<Input
								label="phone"
								value={phone}
								onChange={(e) => setPhone(e.target.value)}
							/>
							<Input
								label="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								isRequired={false}
							/>
							<Select
								label="currency"
								value={currency}
								onChange={(e) =>
									setCurrency(e.target.value as "USD" | "MXN")
								}
								options={currencyOptions}
							/>
						</Form>
					</Card>
				</PageLayout>
			)}
		</>
	);
};

export default SupplierRoute;
